module.exports = __webpack_public_path__ + "static/media/x-button.6958c801.svg";